var render = function () {
  var _vm$form$title, _vm$form, _vm$form$title2, _vm$form2;
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_c('div', {
    staticClass: "row page-title-header"
  }, [_c('div', {
    staticClass: "col-12"
  }, [_c('BreadCrumb', {
    attrs: {
      "parentRouteName": "FormList",
      "extra-items": _vm.isReadOnly ? [{
        text: (_vm$form$title = (_vm$form = _vm.form) === null || _vm$form === void 0 ? void 0 : _vm$form.title) !== null && _vm$form$title !== void 0 ? _vm$form$title : ''
      }] : _vm.isEditing ? [{
        text: (_vm$form$title2 = (_vm$form2 = _vm.form) === null || _vm$form2 === void 0 ? void 0 : _vm$form2.title) !== null && _vm$form$title2 !== void 0 ? _vm$form$title2 : '',
        to: 'FormRead',
        params: _vm.$route.params.id
      }, '編輯表單'] : ['新增表單']
    }
  })], 1)]), _c('div', {
    staticClass: "email-wrapper wrapper"
  }, [_c('div', {
    staticClass: "row bg-white"
  }, [_c('div', {
    staticClass: "col-md-2 mail-sidebar pt-3"
  }, [_c('div', {
    staticClass: "menu-bar"
  }, [_c('ul', {
    staticClass: "menu-items"
  }, [_c('li', {
    class: {
      active: _vm.step == '',
      done: _vm.form.id
    },
    on: {
      "click": function click($event) {
        return _vm.goToStep('');
      }
    }
  }, [_c('a', [_vm._v("基本設定")]), _c('i', {
    staticClass: "fa fa-check-circle icon-for-done",
    attrs: {
      "aria-hidden": "true"
    }
  }), _c('i', {
    staticClass: "fa fa-check-circle-o icon-for-undone ",
    attrs: {
      "aria-hidden": "true"
    }
  })]), _c('li', {
    class: {
      active: _vm.step == '#welcome',
      done: _vm.deepGet(_vm.form, 'config.welcome_page.enable', false),
      disabled: !_vm.form.id
    },
    on: {
      "click": function click($event) {
        return _vm.goToStep('#welcome');
      }
    }
  }, [_c('a', [_vm._v("歡迎頁")]), _c('i', {
    staticClass: "fa fa-check-circle icon-for-done",
    attrs: {
      "aria-hidden": "true"
    }
  }), _c('i', {
    staticClass: "fa fa-check-circle-o icon-for-undone ",
    attrs: {
      "aria-hidden": "true"
    }
  })]), _c('li', {
    class: {
      active: _vm.step == '#content',
      disabled: !_vm.form.id
    },
    on: {
      "click": function click($event) {
        return _vm.goToStep('#content');
      }
    }
  }, [_c('a', [_vm._v("內容頁")])]), _c('li', {
    class: {
      active: _vm.step == '#questionnaire',
      done: _vm.deepGet(_vm.form, 'subjects.length', 0) > 0,
      disabled: !_vm.form.id
    },
    on: {
      "click": function click($event) {
        return _vm.goToStep('#questionnaire');
      }
    }
  }, [_c('a', [_vm._v("內容設定")]), _c('i', {
    staticClass: "fa fa-check-circle icon-for-done",
    attrs: {
      "aria-hidden": "true"
    }
  }), _c('i', {
    staticClass: "fa fa-check-circle-o icon-for-undone ",
    attrs: {
      "aria-hidden": "true"
    }
  })]), _c('li', {
    class: {
      active: _vm.step == '#thanks',
      disabled: !_vm.form.id
    },
    on: {
      "click": function click($event) {
        return _vm.goToStep('#thanks');
      }
    }
  }, [_c('a', [_vm._v("感謝頁")])]), _vm.isApply ? _c('li', {
    class: {
      active: _vm.step == '#confirm',
      disabled: !_vm.form.id
    },
    on: {
      "click": function click($event) {
        return _vm.goToStep('#confirm');
      }
    }
  }, [_c('a', [_vm._v("核銷頁")])]) : _vm._e(), _c('li', {
    class: {
      active: _vm.step == '#limit',
      disabled: !_vm.form.id
    },
    on: {
      "click": function click($event) {
        return _vm.goToStep('#limit');
      }
    }
  }, [_c('a', [_vm._v("上限頁")])]), _c('li', {
    class: {
      active: _vm.step == '#advanced-setting',
      disabled: !_vm.form.id
    },
    on: {
      "click": function click($event) {
        return _vm.goToStep('#advanced-setting');
      }
    }
  }, [_c('a', [_vm._v("進階設定")]), _c('i', {
    staticClass: "fa fa-check-circle icon-for-done",
    attrs: {
      "aria-hidden": "true"
    }
  }), _c('i', {
    staticClass: "fa fa-check-circle-o icon-for-undone ",
    attrs: {
      "aria-hidden": "true"
    }
  })]), _vm.isEvent ? _c('li', {
    class: {
      active: _vm.step == '#event-setting',
      disabled: !_vm.form.id
    },
    on: {
      "click": function click($event) {
        return _vm.goToStep('#event-setting');
      }
    }
  }, [_c('a', [_vm._v("活動設定")])]) : _vm._e()])])]), _c('div', {
    staticClass: "col-md-10 main-view"
  }, [_c('b-overlay', {
    attrs: {
      "show": _vm.showLoading
    }
  }, [_c('b-card', [_vm.step == '' ? _c('section', [_c('h4', {
    staticClass: "mb-3 font-weight-bold"
  }, [_vm._v(_vm._s(_vm.isEditing ? '編輯表單' : _vm.isReadOnly ? '檢視表單' : '新增表單'))]), _c('div', {
    staticClass: "row mb-2"
  }, [_c('div', {
    staticClass: "col-12 col-xl-10"
  }, [_vm.validationErrors ? _c('validation-error-alert', {
    attrs: {
      "errors": _vm.validationErrors
    }
  }) : _vm._e(), _c('b-form-group', {
    attrs: {
      "label-cols": "12",
      "label-cols-lg": "2",
      "label-size": "sm",
      "label": "* 類型",
      "disabled": _vm.isReadOnly
    }
  }, [_c('b-form-radio-group', {
    model: {
      value: _vm.form.type,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "type", $$v);
      },
      expression: "form.type"
    }
  }, [_vm.checkPermission([_vm.consts.FORM_SURVEY_MODE]) ? _c('b-form-radio', {
    attrs: {
      "value": "survey"
    }
  }, [_vm._v("問卷")]) : _vm._e(), _vm.checkPermission([_vm.consts.FORM_EVENT_MODE]) ? _c('b-form-radio', {
    attrs: {
      "value": "event"
    }
  }, [_vm._v("活動")]) : _vm._e(), _vm.checkPermission([_vm.consts.FORM_APPLY_MODE]) ? _c('b-form-radio', {
    attrs: {
      "value": "apply"
    }
  }, [_vm._v("申請")]) : _vm._e()], 1)], 1), _c('b-form-group', {
    attrs: {
      "label-cols": "12",
      "label-cols-lg": "2",
      "label-size": "sm",
      "label": "* 狀態",
      "disabled": _vm.isReadOnly
    }
  }, [_c('b-select', {
    attrs: {
      "options": [{
        text: '草稿',
        value: 'draft'
      }, {
        text: '公開',
        value: 'published'
      }, {
        text: '關閉',
        value: 'closed'
      }]
    },
    model: {
      value: _vm.form.status,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "status", $$v);
      },
      expression: "form.status"
    }
  })], 1), _c('b-form-group', {
    attrs: {
      "label-cols": "12",
      "label-cols-lg": "2",
      "label-size": "sm",
      "label": "* 名稱",
      "disabled": _vm.isReadOnly
    }
  }, [_c('b-form-input', {
    staticClass: "mb-2 mr-sm-2 mb-sm-0",
    attrs: {
      "type": "text",
      "state": _vm.v$.form.title.$error ? false : null
    },
    model: {
      value: _vm.form.title,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "title", $$v);
      },
      expression: "form.title"
    }
  }), _c('b-form-invalid-feedback', {
    attrs: {
      "state": !_vm.v$.form.title.$error
    }
  }, [_vm._v(" 此欄位為必填 ")])], 1), _c('b-form-group', {
    attrs: {
      "label-cols": "12",
      "label-cols-lg": "2",
      "label-size": "sm",
      "label": "填寫權限",
      "disabled": _vm.isReadOnly
    }
  }, [_c('b-form-checkbox-group', {
    attrs: {
      "options": _vm.permissionOptions
    },
    model: {
      value: _vm.form.config.permissions,
      callback: function callback($$v) {
        _vm.$set(_vm.form.config, "permissions", $$v);
      },
      expression: "form.config.permissions"
    }
  })], 1), _c('b-form-group', {
    attrs: {
      "label-cols": "12",
      "label-cols-lg": "2",
      "label-size": "sm",
      "label": "* 填寫次數",
      "disabled": _vm.isReadOnly
    }
  }, [_c('b-form-radio-group', {
    attrs: {
      "options": [{
        text: '不限定',
        value: 'unlimit'
      }, {
        text: '限定次數',
        value: 'limit'
      }]
    },
    model: {
      value: _vm.fillOutSetting,
      callback: function callback($$v) {
        _vm.fillOutSetting = $$v;
      },
      expression: "fillOutSetting"
    }
  }, [_c('b-form-input', {
    staticClass: "w-25",
    attrs: {
      "type": "number",
      "min": "0",
      "disabled": _vm.fillOutSetting === 'unlimit'
    },
    model: {
      value: _vm.form.fill_out_times,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "fill_out_times", $$v);
      },
      expression: "form.fill_out_times"
    }
  })], 1), _c('b-form-invalid-feedback', {
    attrs: {
      "state": !_vm.v$.fillOutSetting.$error
    }
  }, [_vm._v(" 此欄位為必填 ")])], 1), _vm.fillOutSetting === 'limit' ? _c('b-form-group', {
    attrs: {
      "label-cols": "12",
      "label-cols-lg": "2",
      "label-size": "sm",
      "label": "達上限次數後，顯示",
      "disabled": _vm.isReadOnly
    }
  }, [_c('b-form-radio-group', {
    attrs: {
      "options": [{
        text: '歡迎頁',
        value: 'welcome_page'
      }, {
        text: '感謝頁',
        value: 'thanks_page'
      }, {
        text: '上限頁',
        value: 'limit_page'
      }]
    },
    model: {
      value: _vm.form.config.basic_setting.when_reach_limit_show,
      callback: function callback($$v) {
        _vm.$set(_vm.form.config.basic_setting, "when_reach_limit_show", $$v);
      },
      expression: "form.config.basic_setting.when_reach_limit_show"
    }
  }, [_vm.fillOutSetting == 'limit' && _vm.form.type === 'apply' ? _c('b-form-radio', {
    attrs: {
      "value": "confirm_page"
    }
  }, [_vm._v("核銷頁(最新一筆)")]) : _vm._e()], 1), _c('b-form-invalid-feedback', {
    attrs: {
      "state": !_vm.v$.form.config.basic_setting.when_reach_limit_show.$error
    }
  }, [_vm._v(" 此欄位為必填 ")])], 1) : _vm._e(), _vm.form.type === 'apply' ? _c('b-form-group', {
    attrs: {
      "label-cols": "12",
      "label-cols-lg": "2",
      "label-size": "sm",
      "label": "* 填寫後顯示",
      "disabled": _vm.isReadOnly
    }
  }, [_c('b-form-radio-group', {
    attrs: {
      "options": [{
        text: '感謝頁',
        value: 'thanks_page'
      }, {
        text: '核銷頁',
        value: 'confirm_page'
      }]
    },
    model: {
      value: _vm.form.config.basic_setting.after_fill_out_show,
      callback: function callback($$v) {
        _vm.$set(_vm.form.config.basic_setting, "after_fill_out_show", $$v);
      },
      expression: "form.config.basic_setting.after_fill_out_show"
    }
  }), _c('b-form-invalid-feedback', {
    attrs: {
      "state": !_vm.v$.form.config.basic_setting.after_fill_out_show.$error
    }
  }, [_vm._v(" 此欄位為必填 ")])], 1) : _vm._e(), _c('b-form-group', {
    attrs: {
      "label-cols": "12",
      "label-cols-lg": "2",
      "label-size": "sm",
      "label": "* 開始時間",
      "disabled": _vm.isReadOnly
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12 col-xl-6"
  }, [_c('datepicker', {
    attrs: {
      "placeholder": "選擇日期",
      "bootstrap-styling": "",
      "format": "yyyy-MM-dd",
      "language": _vm.zh
    },
    model: {
      value: _vm.start_at.date,
      callback: function callback($$v) {
        _vm.$set(_vm.start_at, "date", $$v);
      },
      expression: "start_at.date"
    }
  }), _c('b-form-invalid-feedback', {
    attrs: {
      "state": !_vm.v$.start_at.date.required.$error
    }
  }, [_vm._v(" 此欄位為必填 ")])], 1), _c('div', {
    staticClass: "col-12 col-xl-6"
  }, [_c('vue-timepicker', {
    attrs: {
      "placeholder": "選擇時間",
      "format": "HH:mm",
      "input-class": ['form-control']
    },
    model: {
      value: _vm.start_at.time,
      callback: function callback($$v) {
        _vm.$set(_vm.start_at, "time", $$v);
      },
      expression: "start_at.time"
    }
  }), _c('b-form-invalid-feedback', {
    attrs: {
      "state": !_vm.v$.start_at.time.HH.$error || !_vm.v$.start_at.time.mm.$error
    }
  }, [_vm._v(" 此欄位為必填 ")])], 1)])]), _c('b-form-group', {
    attrs: {
      "label-cols": "12",
      "label-cols-lg": "2",
      "label-size": "sm",
      "label": "* 結束時間",
      "disabled": _vm.isReadOnly
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12 col-xl-6"
  }, [_c('datepicker', {
    attrs: {
      "placeholder": "選擇日期",
      "bootstrap-styling": "",
      "format": "yyyy-MM-dd",
      "language": _vm.zh,
      "input-class": _vm.v$.start_at.$invalid ? 'is-invalid' : ''
    },
    model: {
      value: _vm.end_at.date,
      callback: function callback($$v) {
        _vm.$set(_vm.end_at, "date", $$v);
      },
      expression: "end_at.date"
    }
  }), _c('b-form-invalid-feedback', {
    attrs: {
      "state": !_vm.v$.end_at.date.$error
    }
  }, [_vm._v(" 此欄位為必填 ")]), _c('b-form-invalid-feedback', {
    attrs: {
      "state": !_vm.v$.start_at.date.beforeEndAt.$invalid
    }
  }, [_vm._v(" 結束時間必須大於起始時間 ")])], 1), _c('div', {
    staticClass: "col-12 col-xl-6"
  }, [_c('vue-timepicker', {
    attrs: {
      "placeholder": "選擇時間",
      "input-class": ['form-control', {
        'is-invalid': _vm.v$.start_at.time.HH.$error || _vm.v$.start_at.time.mm.$error || _vm.v$.start_at.date.beforeEndAt.$invalid
      }]
    },
    model: {
      value: _vm.end_at.time,
      callback: function callback($$v) {
        _vm.$set(_vm.end_at, "time", $$v);
      },
      expression: "end_at.time"
    }
  }), _c('b-form-invalid-feedback', {
    attrs: {
      "state": !_vm.v$.end_at.time.HH.$error || !_vm.v$.end_at.time.mm.$error
    }
  }, [_vm._v(" 此欄位為必填 ")])], 1)])]), _vm.isEvent ? _c('b-form-group', {
    attrs: {
      "label-cols": "12",
      "label-cols-lg": "2",
      "label-size": "sm",
      "label": "* 報到開始時間",
      "disabled": _vm.isReadOnly
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12 col-xl-6"
  }, [_c('datepicker', {
    attrs: {
      "placeholder": "選擇日期",
      "bootstrap-styling": "",
      "format": "yyyy-MM-dd",
      "language": _vm.zh
    },
    model: {
      value: _vm.checkinStartAt.date,
      callback: function callback($$v) {
        _vm.$set(_vm.checkinStartAt, "date", $$v);
      },
      expression: "checkinStartAt.date"
    }
  }), _c('b-form-invalid-feedback', {
    attrs: {
      "state": !_vm.v$.checkinStartAt.date.required.$error
    }
  }, [_vm._v(" 此欄位為必填 ")])], 1), _c('div', {
    staticClass: "col-12 col-xl-6"
  }, [_c('vue-timepicker', {
    attrs: {
      "placeholder": "選擇時間",
      "format": "HH:mm",
      "input-class": ['form-control']
    },
    model: {
      value: _vm.checkinStartAt.time,
      callback: function callback($$v) {
        _vm.$set(_vm.checkinStartAt, "time", $$v);
      },
      expression: "checkinStartAt.time"
    }
  }), _c('b-form-invalid-feedback', {
    attrs: {
      "state": !_vm.v$.checkinStartAt.time.HH.$error || !_vm.v$.checkinStartAt.time.mm.$error
    }
  }, [_vm._v(" 此欄位為必填 ")])], 1)])]) : _vm._e(), _vm.isEvent ? _c('b-form-group', {
    attrs: {
      "label-cols": "12",
      "label-cols-lg": "2",
      "label-size": "sm",
      "label": "* 報到結束時間",
      "disabled": _vm.isReadOnly
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-12 col-xl-6"
  }, [_c('datepicker', {
    attrs: {
      "placeholder": "選擇日期",
      "bootstrap-styling": "",
      "format": "yyyy-MM-dd",
      "language": _vm.zh,
      "input-class": _vm.v$.checkinStartAt.$invalid ? 'is-invalid' : ''
    },
    model: {
      value: _vm.checkinEndAt.date,
      callback: function callback($$v) {
        _vm.$set(_vm.checkinEndAt, "date", $$v);
      },
      expression: "checkinEndAt.date"
    }
  }), _c('b-form-invalid-feedback', {
    attrs: {
      "state": !_vm.v$.checkinEndAt.date.$error
    }
  }, [_vm._v(" 此欄位為必填 ")]), _c('b-form-invalid-feedback', {
    attrs: {
      "state": !_vm.v$.checkinStartAt.date.beforeEndAt.$invalid
    }
  }, [_vm._v(" 結束時間必須大於起始時間 ")])], 1), _c('div', {
    staticClass: "col-12 col-xl-6"
  }, [_c('vue-timepicker', {
    attrs: {
      "placeholder": "選擇時間",
      "input-class": ['form-control', {
        'is-invalid': _vm.v$.checkinStartAt.time.HH.$error || _vm.v$.checkinStartAt.time.mm.$error || _vm.v$.checkinStartAt.date.beforeEndAt.$invalid
      }]
    },
    model: {
      value: _vm.checkinEndAt.time,
      callback: function callback($$v) {
        _vm.$set(_vm.checkinEndAt, "time", $$v);
      },
      expression: "checkinEndAt.time"
    }
  }), _c('b-form-invalid-feedback', {
    attrs: {
      "state": !_vm.v$.checkinEndAt.time.HH.$error || !_vm.v$.checkinEndAt.time.mm.$error
    }
  }, [_vm._v(" 此欄位為必填 ")])], 1)])]) : _vm._e(), _vm.featureToggles.form_repeat_submit ? _c('b-form-group', {
    attrs: {
      "label-cols": "12",
      "label-cols-lg": "2",
      "label-size": "sm",
      "label": "* 重複填寫設定",
      "disabled": _vm.isReadOnly
    }
  }, [_c('b-form-radio-group', {
    attrs: {
      "options": [{
        text: '限填寫一次',
        value: 'once'
      }, {
        text: '允許重複新增',
        value: 'repeat'
      }, {
        text: '允許重複填寫，但維持一份紀錄',
        value: 'repeat_one'
      }]
    },
    model: {
      value: _vm.form.config.repeat_submit,
      callback: function callback($$v) {
        _vm.$set(_vm.form.config, "repeat_submit", $$v);
      },
      expression: "form.config.repeat_submit"
    }
  })], 1) : _vm._e(), _vm.featureToggles.form_remember_in_browser ? _c('b-form-group', {
    attrs: {
      "label-cols": "12",
      "label-cols-lg": "2",
      "label-size": "sm",
      "label": "瀏覽器紀錄",
      "description": "每個欄位的答案在送出前，都會記錄在瀏覽器，不會因為誤關視窗而消失",
      "disabled": _vm.isReadOnly
    }
  }, [_c('b-form-checkbox', {
    model: {
      value: _vm.form.config.remember_in_browser,
      callback: function callback($$v) {
        _vm.$set(_vm.form.config, "remember_in_browser", $$v);
      },
      expression: "form.config.remember_in_browser"
    }
  }, [_vm._v("啟用")])], 1) : _vm._e()], 1)]), !_vm.isReadOnly ? _c('div', {
    staticClass: "d-flex justify-content-center preserve-spacing-for-datetime-picker"
  }, [_c('b-button', {
    staticClass: "mr-3",
    attrs: {
      "variant": "outline-danger"
    },
    on: {
      "click": _vm.cancel
    }
  }, [_vm._v(" 返回 ")]), _c('b-button', {
    attrs: {
      "variant": "success"
    },
    on: {
      "click": _vm.submit
    }
  }, [_vm._v(" 儲存 ")])], 1) : _vm._e()]) : _vm._e(), _vm.step == '#welcome' && _vm.form.config.welcome_page ? _c('section', [_c('h4', {
    staticClass: "mb-3 font-weight-bold"
  }, [_vm._v("歡迎頁")]), _vm.validationErrors ? _c('validation-error-alert', {
    attrs: {
      "errors": _vm.validationErrors
    }
  }) : _vm._e(), _c('b-form-group', {
    attrs: {
      "label-cols": "12",
      "label-cols-lg": "3",
      "label-size": "sm",
      "label": "啟用",
      "disabled": _vm.isReadOnly
    }
  }, [_c('b-form-checkbox', {
    model: {
      value: _vm.form.config.welcome_page.enable,
      callback: function callback($$v) {
        _vm.$set(_vm.form.config.welcome_page, "enable", $$v);
      },
      expression: "form.config.welcome_page.enable"
    }
  }, [_vm._v("啟用")])], 1), _c('b-form-group', {
    attrs: {
      "label-cols": "12",
      "label-cols-lg": "3",
      "label-size": "sm",
      "content-cols": "12",
      "content-cols-lg": "6",
      "disabled": _vm.isReadOnly
    },
    scopedSlots: _vm._u([{
      key: "label",
      fn: function fn() {
        return [_vm._v(" Banner "), _c('p', {
          staticClass: "text-black-50 mt-2",
          staticStyle: {
            "font-size": ".75rem"
          }
        }, [_vm._v("寬 x 高：1400px x 700px")])];
      },
      proxy: true
    }, {
      key: "default",
      fn: function fn() {
        return [_vm.selectedImages['welcome_banner_image'] ? _c('li', {
          staticClass: "s-image-list-item s-draggable"
        }, [_c('img', {
          staticClass: "s-cropped-image",
          attrs: {
            "src": _vm.selectedImages['welcome_banner_image']
          }
        }), _c('button', {
          staticClass: "btn btn-danger s-delete-btn",
          attrs: {
            "type": "button"
          },
          on: {
            "click": function click($event) {
              return _vm.selectImage(null, 'welcome_banner_image');
            }
          }
        }, [_vm._v(" Ｘ ")])]) : _c('li', {
          staticClass: "s-image-list-item"
        }, [_c('ImageSelector', {
          attrs: {
            "aspect-ratio": 1400 / 700
          },
          on: {
            "input": function input(croppedImage) {
              return _vm.selectImage(croppedImage, 'welcome_banner_image');
            }
          },
          scopedSlots: _vm._u([{
            key: "trigger",
            fn: function fn(_ref) {
              var openFileSelector = _ref.openFileSelector;
              return [_c('button', {
                staticClass: "btn s-trigger-btn",
                attrs: {
                  "disabled": !_vm.form.config.welcome_page.enable
                },
                on: {
                  "click": openFileSelector
                }
              }, [_vm._v(" ＋ 加入照片 ")])];
            }
          }], null, false, 4129276918)
        })], 1)];
      },
      proxy: true
    }], null, false, 4062146520)
  }), _c('b-form-group', {
    attrs: {
      "label-cols": "12",
      "label-cols-lg": "3",
      "label-size": "sm",
      "label": "標題",
      "disabled": _vm.isReadOnly
    }
  }, [_c('b-form-input', {
    staticClass: "mb-2 mr-sm-2 mb-sm-0",
    attrs: {
      "type": "text",
      "disabled": !_vm.form.config.welcome_page.enable,
      "state": _vm.deepGet(_vm.v$, 'form.config.welcome_page.form_title.$error') ? false : null
    },
    model: {
      value: _vm.form.config.welcome_page.form_title,
      callback: function callback($$v) {
        _vm.$set(_vm.form.config.welcome_page, "form_title", $$v);
      },
      expression: "form.config.welcome_page.form_title"
    }
  }), _c('b-form-invalid-feedback', {
    attrs: {
      "state": !_vm.deepGet(_vm.v$, 'form.config.welcome_page.form_title.$error')
    }
  }, [_vm._v(" 此欄位為必填 ")])], 1), _c('b-form-group', {
    attrs: {
      "label-cols": "12",
      "label-cols-lg": "3",
      "label-size": "sm",
      "label": "副標題",
      "disabled": _vm.isReadOnly
    }
  }, [_c('b-form-input', {
    staticClass: "mb-2 mr-sm-2 mb-sm-0",
    attrs: {
      "type": "text",
      "disabled": !_vm.form.config.welcome_page.enable,
      "state": _vm.deepGet(_vm.v$, 'form.config.welcome_page.form_desc.$error') ? false : null
    },
    model: {
      value: _vm.form.config.welcome_page.form_desc,
      callback: function callback($$v) {
        _vm.$set(_vm.form.config.welcome_page, "form_desc", $$v);
      },
      expression: "form.config.welcome_page.form_desc"
    }
  }), _c('b-form-invalid-feedback', {
    attrs: {
      "state": !_vm.deepGet(_vm.v$, 'form.config.welcome_page.form_desc.$error')
    }
  }, [_vm._v(" 此欄位為必填 ")])], 1), _c('b-form-group', {
    attrs: {
      "label-cols": "12",
      "label-cols-lg": "3",
      "label-size": "sm",
      "label": "內容說明",
      "disabled": _vm.isReadOnly
    }
  }, [_c('TrixEditor', {
    attrs: {
      "readonly": !_vm.form.config.welcome_page.enable || _vm.isReadOnly
    },
    model: {
      value: _vm.form.config.welcome_page.content,
      callback: function callback($$v) {
        _vm.$set(_vm.form.config.welcome_page, "content", $$v);
      },
      expression: "form.config.welcome_page.content"
    }
  }), _c('b-form-invalid-feedback', {
    attrs: {
      "state": !_vm.deepGet(_vm.v$, 'form.config.welcome_page.content.$error')
    }
  }, [_vm._v(" 此欄位為必填 ")])], 1), _c('b-form-group', {
    attrs: {
      "label-cols": "12",
      "label-cols-lg": "3",
      "label-size": "sm",
      "label": "按鈕文字",
      "disabled": _vm.isReadOnly
    }
  }, [_c('b-form-input', {
    staticClass: "mb-2 mr-sm-2 mb-sm-0",
    attrs: {
      "type": "text",
      "disabled": !_vm.form.config.welcome_page.enable,
      "state": _vm.deepGet(_vm.v$, 'form.config.welcome_page.button_text.$error') ? false : null
    },
    model: {
      value: _vm.form.config.welcome_page.button_text,
      callback: function callback($$v) {
        _vm.$set(_vm.form.config.welcome_page, "button_text", $$v);
      },
      expression: "form.config.welcome_page.button_text"
    }
  }), _c('b-form-invalid-feedback', {
    attrs: {
      "state": !_vm.deepGet(_vm.v$, 'form.config.welcome_page.button_text.$error')
    }
  }, [_vm._v(" 此欄位為必填 ")])], 1), !_vm.isReadOnly ? _c('div', {
    staticClass: "d-flex justify-content-center"
  }, [_c('b-button', {
    staticClass: "mr-3",
    attrs: {
      "variant": "outline-danger"
    },
    on: {
      "click": _vm.cancel
    }
  }, [_vm._v(" 返回 ")]), _c('b-button', {
    attrs: {
      "variant": "success"
    },
    on: {
      "click": _vm.submitWelcomePage
    }
  }, [_vm._v(" 儲存 ")])], 1) : _vm._e()], 1) : _vm._e(), _vm.step == '#content' && _vm.form.config.content_page ? _c('section', [_c('h4', {
    staticClass: "mb-3 font-weight-bold"
  }, [_vm._v("內容頁")]), _vm.validationErrors ? _c('validation-error-alert', {
    attrs: {
      "errors": _vm.validationErrors
    }
  }) : _vm._e(), _c('b-form-group', {
    attrs: {
      "label-cols": "12",
      "label-cols-lg": "3",
      "label-size": "sm",
      "content-cols": "12",
      "content-cols-lg": "6",
      "disabled": _vm.isReadOnly
    },
    scopedSlots: _vm._u([{
      key: "label",
      fn: function fn() {
        return [_vm._v(" Banner "), _c('p', {
          staticClass: "text-black-50 mt-2",
          staticStyle: {
            "font-size": ".75rem"
          }
        }, [_vm._v("寬 x 高：1400px x 700px")])];
      },
      proxy: true
    }, {
      key: "default",
      fn: function fn() {
        return [_vm.selectedImages['content_banner_image'] ? _c('li', {
          staticClass: "s-image-list-item s-draggable"
        }, [_c('img', {
          staticClass: "s-cropped-image",
          attrs: {
            "src": _vm.selectedImages['content_banner_image']
          }
        }), _c('button', {
          staticClass: "btn btn-danger s-delete-btn",
          attrs: {
            "type": "button"
          },
          on: {
            "click": function click($event) {
              return _vm.selectImage(null, 'content_banner_image');
            }
          }
        }, [_vm._v(" Ｘ ")])]) : _c('li', {
          staticClass: "s-image-list-item"
        }, [_c('ImageSelector', {
          attrs: {
            "aspect-ratio": 1400 / 700
          },
          on: {
            "input": function input(croppedImage) {
              return _vm.selectImage(croppedImage, 'content_banner_image');
            }
          },
          scopedSlots: _vm._u([{
            key: "trigger",
            fn: function fn(_ref2) {
              var openFileSelector = _ref2.openFileSelector;
              return [_c('button', {
                staticClass: "btn s-trigger-btn",
                on: {
                  "click": openFileSelector
                }
              }, [_vm._v(" ＋ 加入照片 ")])];
            }
          }], null, false, 832809640)
        })], 1)];
      },
      proxy: true
    }], null, false, 2768180113)
  }), _c('b-form-group', {
    attrs: {
      "label-cols": "12",
      "label-cols-lg": "3",
      "label-size": "sm",
      "label": "標題",
      "disabled": _vm.isReadOnly
    }
  }, [_c('b-form-input', {
    staticClass: "mb-2 mr-sm-2 mb-sm-0",
    attrs: {
      "type": "text",
      "state": _vm.deepGet(_vm.v$, 'form.config.content_page.form_title.$error') ? false : null
    },
    model: {
      value: _vm.form.config.content_page.form_title,
      callback: function callback($$v) {
        _vm.$set(_vm.form.config.content_page, "form_title", $$v);
      },
      expression: "form.config.content_page.form_title"
    }
  }), _c('b-form-invalid-feedback', {
    attrs: {
      "state": !_vm.deepGet(_vm.v$, 'form.config.content_page.form_title.$error')
    }
  }, [_vm._v(" 此欄位為必填 ")])], 1), _c('b-form-group', {
    attrs: {
      "label-cols": "12",
      "label-cols-lg": "3",
      "label-size": "sm",
      "label": "副標題",
      "disabled": _vm.isReadOnly
    }
  }, [_c('b-form-input', {
    staticClass: "mb-2 mr-sm-2 mb-sm-0",
    attrs: {
      "type": "text",
      "state": _vm.deepGet(_vm.v$, 'form.config.content_page.form_desc.$error') ? false : null
    },
    model: {
      value: _vm.form.config.content_page.form_desc,
      callback: function callback($$v) {
        _vm.$set(_vm.form.config.content_page, "form_desc", $$v);
      },
      expression: "form.config.content_page.form_desc"
    }
  }), _c('b-form-invalid-feedback', {
    attrs: {
      "state": !_vm.deepGet(_vm.v$, 'form.config.content_page.form_desc.$error')
    }
  }, [_vm._v(" 此欄位為必填 ")])], 1), _c('b-form-group', {
    attrs: {
      "label-cols": "12",
      "label-cols-lg": "3",
      "label-size": "sm",
      "label": "內容說明",
      "disabled": _vm.isReadOnly
    }
  }, [_c('TrixEditor', {
    attrs: {
      "readonly": _vm.isReadOnly
    },
    model: {
      value: _vm.form.config.content_page.content,
      callback: function callback($$v) {
        _vm.$set(_vm.form.config.content_page, "content", $$v);
      },
      expression: "form.config.content_page.content"
    }
  }), _c('b-form-invalid-feedback', {
    attrs: {
      "state": !_vm.deepGet(_vm.v$, 'form.config.content_page.content.$error')
    }
  }, [_vm._v(" 此欄位為必填 ")])], 1), _c('b-form-group', {
    attrs: {
      "label-cols": "12",
      "label-cols-lg": "3",
      "label-size": "sm",
      "label": "按鈕文字",
      "disabled": _vm.isReadOnly
    }
  }, [_c('b-form-input', {
    staticClass: "mb-2 mr-sm-2 mb-sm-0",
    attrs: {
      "type": "text",
      "state": _vm.deepGet(_vm.v$, 'form.config.content_page.button_text.$error') ? false : null
    },
    model: {
      value: _vm.form.config.content_page.button_text,
      callback: function callback($$v) {
        _vm.$set(_vm.form.config.content_page, "button_text", $$v);
      },
      expression: "form.config.content_page.button_text"
    }
  }), _c('b-form-invalid-feedback', {
    attrs: {
      "state": !_vm.deepGet(_vm.v$, 'form.config.content_page.button_text.$error')
    }
  }, [_vm._v(" 此欄位為必填 ")])], 1), _c('b-form-group', {
    attrs: {
      "label-cols": "12",
      "label-cols-lg": "3",
      "label-size": "sm",
      "label": "使用條款與聲明",
      "disabled": _vm.isReadOnly
    }
  }, [_c('classic-editor', {
    attrs: {
      "disabled": _vm.isReadOnly
    },
    model: {
      value: _vm.form.terms,
      callback: function callback($$v) {
        _vm.$set(_vm.form, "terms", $$v);
      },
      expression: "form.terms"
    }
  })], 1), !_vm.isReadOnly ? _c('div', {
    staticClass: "d-flex justify-content-center"
  }, [_c('b-button', {
    staticClass: "mr-3",
    attrs: {
      "variant": "outline-danger"
    },
    on: {
      "click": _vm.cancel
    }
  }, [_vm._v(" 返回 ")]), _c('b-button', {
    attrs: {
      "variant": "success"
    },
    on: {
      "click": _vm.submitContentPage
    }
  }, [_vm._v(" 儲存 ")])], 1) : _vm._e()], 1) : _vm._e(), _vm.step == '#questionnaire' ? _c('section', [_vm.form.id ? _c('DynamicFormEditor', {
    attrs: {
      "editor-title": "內容設定",
      "input-subjects": _vm.form.subjects,
      "readonly": _vm.isReadOnly,
      "form-type": 'survey',
      "validate-subject": _vm.validSubject,
      "validation-message": "標題不得為空"
    },
    on: {
      "output": function output($event) {
        return _vm.saveSubjects($event);
      },
      "cancel": function cancel($event) {
        return _vm.$router.push({
          name: 'FormList'
        });
      }
    }
  }) : _vm._e()], 1) : _vm._e(), _vm.step == '#thanks' && _vm.form.config.thanks_page ? _c('section', [_c('ThanksPage', {
    attrs: {
      "form": _vm.form,
      "imageUrl": _vm.selectedImages['thanks_banner_image'],
      "readonly": _vm.isReadOnly
    },
    on: {
      "loading": function loading($event) {
        _vm.showLoading = $event;
      },
      "submit": _vm.submit,
      "cancel": _vm.cancel
    }
  })], 1) : _vm._e(), _vm.step == '#confirm' && _vm.form.config.confirm_page ? _c('section', [_c('ConfirmPage', {
    attrs: {
      "form": _vm.form,
      "imageUrl": _vm.selectedImages['confirm_banner_image'],
      "readonly": _vm.isReadOnly
    },
    on: {
      "loading": function loading($event) {
        _vm.showLoading = $event;
      },
      "submit": _vm.submit,
      "cancel": _vm.cancel
    }
  })], 1) : _vm._e(), _vm.step == '#limit' && _vm.form.config.limit_page ? _c('section', [_c('LimitPage', {
    attrs: {
      "form": _vm.form,
      "imageUrl": _vm.selectedImages['limit_banner_image'],
      "readonly": _vm.isReadOnly
    },
    on: {
      "loading": function loading($event) {
        _vm.showLoading = $event;
      },
      "submit": _vm.submit,
      "cancel": _vm.cancel
    }
  })], 1) : _vm._e(), _vm.step == '#advanced-setting' && _vm.form.config.advanced_setting ? _c('section', [_c('h4', {
    staticClass: "mb-3 font-weight-bold"
  }, [_vm._v("進階設定")]), _c('b-form-group', {
    attrs: {
      "label-cols": "12",
      "label-cols-lg": "3",
      "label-size": "sm",
      "label": "填寫後立即推播",
      "disabled": _vm.isReadOnly
    }
  }, [_c('b-form-input', {
    attrs: {
      "placeholder": "請輸入Template Code"
    },
    model: {
      value: _vm.form.config.advanced_setting.notify_after_fill_out_template_code,
      callback: function callback($$v) {
        _vm.$set(_vm.form.config.advanced_setting, "notify_after_fill_out_template_code", $$v);
      },
      expression: "form.config.advanced_setting.notify_after_fill_out_template_code"
    }
  }), _c('b-form-checkbox', {
    attrs: {
      "disabled": !_vm.form.config.advanced_setting.notify_after_fill_out_template_code
    },
    model: {
      value: _vm.form.config.advanced_setting.notify_after_fill_out,
      callback: function callback($$v) {
        _vm.$set(_vm.form.config.advanced_setting, "notify_after_fill_out", $$v);
      },
      expression: "form.config.advanced_setting.notify_after_fill_out"
    }
  }, [_vm._v("啟用")])], 1), _c('b-form-group', {
    attrs: {
      "label-cols": "12",
      "label-cols-lg": "3",
      "label-size": "sm",
      "label": "填寫後貼標",
      "disabled": _vm.isReadOnly
    }
  }, [_c('TagsBox', {
    model: {
      value: _vm.form.config.advanced_setting.finish_tags,
      callback: function callback($$v) {
        _vm.$set(_vm.form.config.advanced_setting, "finish_tags", $$v);
      },
      expression: "form.config.advanced_setting.finish_tags"
    }
  })], 1), !_vm.isReadOnly ? _c('div', {
    staticClass: "d-flex justify-content-center"
  }, [_c('b-button', {
    staticClass: "mr-3",
    attrs: {
      "variant": "outline-danger"
    },
    on: {
      "click": _vm.cancel
    }
  }, [_vm._v(" 返回 ")]), _c('b-button', {
    attrs: {
      "variant": "success"
    },
    on: {
      "click": _vm.submitAdvancedSetting
    }
  }, [_vm._v(" 儲存 ")])], 1) : _vm._e()], 1) : _vm._e(), _vm.step == '#event-setting' ? _c('section', [_c('h4', {
    staticClass: "mb-3 font-weight-bold"
  }, [_vm._v("活動設定")]), _c('b-form-group', {
    attrs: {
      "label-cols": "12",
      "label-cols-lg": "3",
      "label-size": "sm",
      "label": "是否需審核",
      "disabled": _vm.isReadOnly
    }
  }, [_c('b-form-radio-group', {
    attrs: {
      "options": [{
        text: '需審核',
        value: true
      }, {
        text: '不審核(報名後立即通過)',
        value: false
      }]
    },
    model: {
      value: _vm.form.config.event_setting.enable_verify,
      callback: function callback($$v) {
        _vm.$set(_vm.form.config.event_setting, "enable_verify", $$v);
      },
      expression: "form.config.event_setting.enable_verify"
    }
  })], 1), _c('b-form-group', {
    attrs: {
      "label-cols": "12",
      "label-cols-lg": "3",
      "label-size": "sm",
      "label": "是否開啟手動報到",
      "disabled": _vm.isReadOnly
    }
  }, [_c('b-form-radio-group', {
    attrs: {
      "options": [{
        text: '開啟',
        value: true
      }, {
        text: '關閉',
        value: false
      }]
    },
    model: {
      value: _vm.form.config.event_setting.enable_manual_checkin,
      callback: function callback($$v) {
        _vm.$set(_vm.form.config.event_setting, "enable_manual_checkin", $$v);
      },
      expression: "form.config.event_setting.enable_manual_checkin"
    }
  })], 1), _c('b-form-group', {
    attrs: {
      "label-cols": "12",
      "label-cols-lg": "3",
      "label-size": "sm",
      "label": "審核通過貼標",
      "disabled": _vm.isReadOnly
    }
  }, [_c('TagsBox', {
    model: {
      value: _vm.form.config.event_setting.approved_tags,
      callback: function callback($$v) {
        _vm.$set(_vm.form.config.event_setting, "approved_tags", $$v);
      },
      expression: "form.config.event_setting.approved_tags"
    }
  })], 1), _c('b-form-group', {
    attrs: {
      "label-cols": "12",
      "label-cols-lg": "3",
      "label-size": "sm",
      "label": "審核不通過貼標"
    }
  }, [_c('TagsBox', {
    attrs: {
      "disabled": false == _vm.form.config.event_setting.enable_verify
    },
    model: {
      value: _vm.form.config.event_setting.rejected_tags,
      callback: function callback($$v) {
        _vm.$set(_vm.form.config.event_setting, "rejected_tags", $$v);
      },
      expression: "form.config.event_setting.rejected_tags"
    }
  })], 1), _c('b-form-group', {
    attrs: {
      "label-cols": "12",
      "label-cols-lg": "3",
      "label-size": "sm",
      "label": "成功報到(事先報名)貼標",
      "disabled": _vm.isReadOnly
    }
  }, [_c('TagsBox', {
    model: {
      value: _vm.form.config.event_setting.attend_tags,
      callback: function callback($$v) {
        _vm.$set(_vm.form.config.event_setting, "attend_tags", $$v);
      },
      expression: "form.config.event_setting.attend_tags"
    }
  })], 1), _c('b-form-group', {
    attrs: {
      "label-cols": "12",
      "label-cols-lg": "3",
      "label-size": "sm",
      "label": "現場報到(未事先報名)貼標",
      "disabled": _vm.isReadOnly
    }
  }, [_c('TagsBox', {
    model: {
      value: _vm.form.config.event_setting.onsite_checkin_tags,
      callback: function callback($$v) {
        _vm.$set(_vm.form.config.event_setting, "onsite_checkin_tags", $$v);
      },
      expression: "form.config.event_setting.onsite_checkin_tags"
    }
  })], 1), !_vm.isReadOnly ? _c('div', {
    staticClass: "d-flex justify-content-center"
  }, [_c('b-button', {
    staticClass: "mr-3",
    attrs: {
      "variant": "outline-danger"
    },
    on: {
      "click": _vm.cancel
    }
  }, [_vm._v(" 返回 ")]), _c('b-button', {
    attrs: {
      "variant": "success"
    },
    on: {
      "click": _vm.submitEventSetting
    }
  }, [_vm._v(" 儲存 ")])], 1) : _vm._e()], 1) : _vm._e()])], 1)], 1)])])]);
}
var staticRenderFns = []

export { render, staticRenderFns }